// PortalBasic.tsx
// Simple portal rendering directly into document.body
import { ReactNode } from 'react'
import { createPortal } from 'react-dom'
import { AppUiLayer } from './type'

type PortalBasicProps = {
  children: ReactNode
  container?: HTMLElement // optional override
  layer?: AppUiLayer
}

export const Portal = (props: PortalBasicProps) => {
  if ('layer' in props) {
    const container = document.getElementById(`portal-${props.layer}`)
    if (container) {
      return createPortal(props.children, container)
    }
  }

  return createPortal(props.children, props.container ?? document.body)
}
